import React from "react";
import { useSelector } from "react-redux";
import { Button, Modal, Container, Row, Col } from "shared-portal-component";

import { useAppDispatch, type RootState } from "@/store";
import { clearPollingModal } from "@/store/slices/ui/uiSlice";
import { JSON_STR_BASE } from "@/constants";

export const GlobalPollingModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { pollingModal } = useSelector((state: RootState) => state.ui);

  // Only show error modals, never show success modals
  if (pollingModal.type === null || pollingModal.type === 'success') return null;

  const { title, message, details } = pollingModal;

  const handleClose = () => {
    dispatch(clearPollingModal());
  };
  return (
    <Modal
      onClose={handleClose}
      title={title ?? ""}
      size="sm"
      aria-label={title ?? "Modal"}
    >
      <Container className="p-4 text-center">
        <Row spacing="md" justify="center">
          <Col size={12}>
            <p className="mb-2 text-gray-800">{message}</p>
          </Col>
        </Row>

        {(details !== null) && (
          <Row spacing="md" justify="center">
            <Col size={12}>
              <details className="mt-3 text-left">
                <summary className="cursor-pointer font-medium">Details</summary>
                <pre className="whitespace-pre-wrap text-sm mt-2 bg-gray-50 p-3 rounded">
                  {JSON.stringify(details, null, JSON_STR_BASE)}
                </pre>
              </details>
            </Col>
          </Row>
        )}

        <Row spacing="md" justify="center" align="center">

          <Col size="content">
            <Button variant="primary" text="Close" onClick={handleClose} size="md" />
          </Col>
        </Row>
      </Container>
    </Modal>
  );
};
